/** @format */

import { Col, Card, Button } from "react-bootstrap";
import { useState } from "react";
import { useGetUserMe } from "../../../../../../api/queries/user.query";
import SkillsForm from "./skills-form";

const Skill = () => {
  const [isOpen, setOpen] = useState(false);
  const handleToggleSection = () => {
    setOpen(!isOpen);
  };

  const { data: userData, isLoading: isLoadingUserData } = useGetUserMe({
    select: (response) => response.data.user,
  });

  return (
    <Col lg="12">
      <Card>
        <div className="w-full text-end">
          <Button
            variant="success"
            type="button"
            className="btn btn-success mt-4 fw-semibold text-uppercase d-flex align-items-center ms-auto"
            onClick={handleToggleSection}
          >
            <span className="material-symbols-outlined">add</span>
            Add New Skills
          </Button>
        </div>
        <div
          style={{
            maxHeight: isOpen ? "800px" : "0",
            opacity: isOpen ? 1 : 0,
            overflow: "hidden",
            transition: "all 300ms ease-in-out",
          }}
        >
          <SkillsForm />
        </div>
        <Card.Header className="d-flex justify-content-between">
          <div className="header-title">
            <h4 className="card-title">Skills</h4>
          </div>
        </Card.Header>
        {isLoadingUserData ? (
          <h2>Loading...</h2>
        ) : userData && userData.skills ? (
          <div className="container">
            <div className="row">
              {userData.skills.map((skill) => (
                <div className="col-md-6 col-lg-4" key={skill.id}>
                  <Card className="skill-card">
                    <h6 className="skill-name">{skill.name}</h6>
                    <span className="material-symbols-outlined delete-icon">
                      delete
                    </span>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-4">
                <Card className="border border-success mt-2">
                  <h6 className="p-3">No Skills Found</h6>
                </Card>
              </div>
            </div>
          </div>
        )}
      </Card>
    </Col>
  );
};

export default Skill;
